import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import {
	CurrencyAmountPipe,
	DollarShorthandPipe,
} from '@marmon/frontend/common';
import { TuiHint } from '@taiga-ui/core';
import { AnalysisCardComponent } from '../analysis-card/analysis-card.component';
import { DistributionBoxComponent } from '../box-distribution-card/distribution-box/distribution-box.component';
import { BoxDistributionCardBaseComponent } from './box-distribution-card-base.component';

@Component({
	standalone: true,
	imports: [
		AnalysisCardComponent,
		TuiHint,
		TranslocoPipe,
		CurrencyAmountPipe,
		DistributionBoxComponent,
		DollarShorthandPipe,
	],
	selector: 'mar-no-target-box-distribution-card',
	templateUrl: 'box-distribution-card.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	host: { class: 'contents' },
})
export class NoTargetBoxDistributionCardComponent extends BoxDistributionCardBaseComponent {
	override readonly targets = null;
}
